/* eslint no-useless-escape: 0 */

const of = "Seeing in the dark\nThinking through a spark\n\n\nMolting into the next thing from the last thing\nAll in the name of succession\n\n\nBreathing in the light\nInstincts force the fight\n\n\nResilient of one more thing like it's the next thing\nAll in the name of connection\n\n\nYou grow\nYou lunge\nYou climb\nYou jum\nYou stalk\nYou feed\nYou sire\nYou breed"

export default of;